var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"modal-signup","width":620}},[(_vm.activeElem === 'login')?_c('login'):_vm._e(),(_vm.activeElem === 'register')?_c('register'):_vm._e(),(_vm.activeElem === 'forgot-pass')?_c('forgot-pass'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }